import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { method: { type: String, default: "GET" } }

  connect() {
    this.element.dataset.action = "remote-modal#load"
    this.modal = $(this.data.get("modalSelector") || "#ajax-modal")
  }

  load(event) {
    event.preventDefault()

    const options = {
      url: this.element.href,
      type: this.methodValue,
      dataType: "html"
    }

    if (this.methodValue.toUpperCase() !== "GET") {
      const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
      if (!csrfToken) {
        console.error("remote-modal: CSRF token meta tag not found; aborting non-GET request")
        return
      }
      options.headers = { "X-CSRF-Token": csrfToken }
    }

    $.ajax(options).done((html) => {
      this.modal.find(".modal-content").html(html)
      this.modal.modal("show")
    }).fail((xhr, status, error) => {
      alert("Failed to load data: " + error)
    })
  }
}
